import { theme } from 'antd';
import { LogoutIcon, UserIcon } from 'assets/images/svg';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { appActions } from 'reduxStore/app/slice';
import { PersonProfileImage } from 'zComponents/atoms';
import { Dropdown, Flex, Typography } from 'zui/Antd';

const { Text, Title } = Typography;

const DropdownUserProfile = ({ setOpenSignOutModal }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const {
		token: {
			fontSizeSM,
			fontWeightStrong,
			boxShadow,
			colorText,
			colorBgContainer,
			borderRadius,
			borderRadiusLG,
			boxShadowTertiary,
			paddingMD,
			paddingXL,
			marginXS,
		}
	} = theme.useToken();

	const person = useSelector((state) => state.Auth.selectedProfile);

	// Define menu items
	const items = [
		{
			key: '1',
			label: 'Profile Settings',
			icon: <UserIcon style={{ marginLeft: 14 }} />,
			style: { marginBottom: marginXS },
			onClick: (e) => {
				navigate('settings');
				dispatch(appActions.changeCurrent(['settings']));
			}
		},
		{
			key: '2',
			label: 'Log Out',
			icon: <LogoutIcon style={{ marginLeft: 14 }} />,
			onClick: () => setOpenSignOutModal(true)
		}
	];

	return (
		<Dropdown
			arrow
			menu={{ items }}
			placement='bottomRight'
			trigger={['click']}
			dropdownRender={(menu) => (
				<Flex
					style={{
						boxShadow: boxShadow,
						background: colorBgContainer,
						borderRadius: borderRadius
					}}
					vertical
				>
					<Flex
						align='center'
						gap={17}
						style={{
							padding: `${paddingMD}px ${paddingXL}px`,
							boxShadow: boxShadowTertiary,
							borderRadius: borderRadiusLG
						}}
					>
						<PersonProfileImage
							size={38}
							photoUrl={person.photoUrl}
							entityName={'People'}
							name={person?.displayName}
							shape={'circle'}
							edit={false}
						/>
						<Flex vertical>
							<Title style={{ fontWeight: fontWeightStrong, margin: 0, lineHeight: '24px' }} level={5}>
								{person.displayName || `${person.firstName} ${person.lastName}`}
							</Title>
							<Text
								style={{ fontSize: fontSizeSM, color: colorText, lineHeight: '20px' }}
								ellipsis={{ tooltip: true }}
							>
								{person.email}
							</Text>
						</Flex>
					</Flex>

					{React.cloneElement(menu, {
						style: {
							padding: 'none',
							boxShadow: 'none',
							backgroundColor: 'transparent',
							margin: 10
						}
					})}
				</Flex>
			)}
		>
			<div
				style={{
					lineHeight: 0
				}}
			>
				<PersonProfileImage
					size={37}
					photoUrl={person.photoUrl}
					name={person?.displayName}
					entityName={'People'}
					shape={'circle'}
					edit={false}
					cursor
				/>
			</div>
		</Dropdown>
	);
};

export default DropdownUserProfile;
